import script from "./on-site.vue?vue&type=script&setup=true&lang=js"
export * from "./on-site.vue?vue&type=script&setup=true&lang=js"

import "./on-site.vue?vue&type=style&index=0&id=0f15eaa2&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f15eaa2"]])

export default __exports__